import SignUp from "./signup.container";

export default SignUp